import { ofType, ActionsObservable } from 'redux-observable';
import { map, mergeMap, flatMap } from 'rxjs/operators';
import { from } from 'rxjs';
import {format} from 'one-util-date';

import {
    setAction,setError
} from 'one-state-prescriptionrefills/src/actions';

import {
    addAction
} from 'one-state-error/src/actions';

import {
    ErrorObject
} from 'one-state-error/src/errorobject';
import { TransformResponse } from './transform';
import { Disposition } from 'one-model-local';

export const enum Types {
    REFILLREQUEST = 'one-state-prescriptionrefills/fetch',
    STORE_DISPOSITION_CODE = "store-disposition-code",
}
const pushToDisposition = (payload: any) => ({ type: Types.STORE_DISPOSITION_CODE, payload });
/**
 * This Fuction will fetch the data of Refills epic
 * from backend api and returns the response and calls
 * subsequent redux action
 * @param context contains the settings etc..
 */

export const fetchRefillEpic = (context: any) => (
    (action$: ActionsObservable<any>,state$: any) => {
        const errorTime = format(new Date(),'LT');
        const errorDate = format(new Date(),'LL');
        const { serverone,
            log,
            agentId,teamName,
            settings:
            {
                epicendpoints: { refillrequest, apitoken },servers,
                compatible : {contact_center_type },
            }
        } = context;
        const { locations = [] } = servers;
        return action$.pipe(
            ofType(Types.REFILLREQUEST),
            mergeMap((action: any) => {
                /**
                 * @param dataresponse contains the Referrals Response
                 */
                let dataresponse: any = action.payload;
                const getRequest = (datares: any) => {

                    if (datares) {
                        let headers = new Headers();
                        headers.set('Authorization', 'Basic ' + apitoken?.token);
                        const data = {
                            "prescriptionId":datares.prescriptionId,
                            "pickupPharmacyNCPDPId": datares.pickupPharmacyNCPDPId,
                            "deliveryMethod": datares.deliveryMethod,
                            "deliveryDestination":datares.deliveryDestination,
                            "deliveryComments":datares.deliveryComments,
                            "pickupDateTime": datares.pickupDateTime,
                            "comments":datares.comments,
                        }
                        const response = serverone.post({
                            path: refillrequest,
                            data: data,
                            headers: headers
                        })
                            .then((responsefound: any) => responsefound)
                            .catch((responseresult: any) => {
                                log.error(
                                    "ccw-gadget,refill-epic",
                                    "setsession-epic", {
                                        responseresult
                                }
                                );
                                let errorbuild: ErrorObject = {
                                    source: "Refill",
                                    type: "error",
                                    status: responseresult?.status,
                                    erroritems: responseresult?.errors,
                                    error_date: errorDate,
                                    error_time: errorTime
                                };
                                return errorbuild;
                        
                            })
                        return from(response)
                    } else {
                        return from([]);
                    }
                }
                //Calling getRequst function here
                //the reason is we need to use pipe function.
                return getRequest(dataresponse).
                    pipe(
                        map((response: any) => TransformResponse(response, context))).
                    pipe(
                        flatMap(response => {
                            const actions: any = [
                                setAction(response?.agentiddata[0])];
                            if (response.error) {
                                actions.push(addAction(response.error));
                                actions.push(setError(response.error));
                                let disp: Disposition = { value: "2027" }
                                if (contact_center_type && contact_center_type === 'five9') {
                                    let agentIdValue = sessionStorage.getItem("agentName");
                                    let skillName = sessionStorage.getItem("skillName");
                                    disp.meta00 = agentIdValue;
                                    disp.meta01 = skillName;
                                    disp.dial_list_uid = state$.value.five9Interaction?.interactionId;
                                } else {
                                    disp.meta00 = agentId;
                                    disp.meta01 = teamName;
                                    disp.dial_list_uid = state$.value.choosecaller?.callId;
                                }
                                disp.meta02 = dataresponse.epic_user;
                                disp.meta03 = response?.error?.status;
                                disp.meta04 = response?.error?.erroritems[0]?.error_detail;
                                disp.meta05 = 'client';
                                actions.push(pushToDisposition(disp));
                            }  else {
                                let disp: Disposition = { value: "2028" }
                                if (contact_center_type && contact_center_type === 'five9') {
                                    let agentIdValue = sessionStorage.getItem("agentName");
                                    let skillName = sessionStorage.getItem("skillName");
                                    disp.meta00 = agentIdValue;
                                    disp.meta01 = skillName;
                                    disp.dial_list_uid = state$.value.five9Interaction?.interactionId;
                                } else {
                                    disp.meta00 = agentId;
                                    disp.meta01 = teamName;
                                    disp.dial_list_uid = state$.value.choosecaller?.callId;
                                }
                                disp.meta02 = dataresponse.epic_user;
                                disp.meta03 = '200';
                                disp.meta04 = 'client';
                                actions.push(pushToDisposition(disp));
                            }
                            return actions;
                        })
                    )
            })
        )
    }
);


